import * as Types from "Types";
import { css } from "styled-components";
import * as cons from "globalConstants";

export const sizes = cons.grid.sizes;
export const sizesNumber = cons.grid.sizesNumber;

export const config: Types.Grid.Config = {
   xxl: {
      count: 24,
      min: 1400,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   },
   xl: {
      count: 16,
      min: 1200,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 1200
   l: {
      count: 12,
      min: 992,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 992
   m: {
      count: 4,
      min: 768,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 768
   s: {
      count: 2,
      min: 576,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 576
   xs: {
      count: 2,
      min: 0,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   },
};

export function getSize(width: number) {
   if (width >= config.xxl.min) return cons.grid.sizes.xxl;
   if (width >= config.xl.min && width < config.xxl.min) return cons.grid.sizes.xl;
   if (width >= config.l.min && width < config.xl.min) return cons.grid.sizes.l;
   if (width >= config.m.min && width < config.l.min) return cons.grid.sizes.m;
   if (width >= config.s.min && width < config.m.min) return cons.grid.sizes.s;
   if (width < config.s.min) return cons.grid.sizes.xs;

   return cons.grid.sizes.xxl;
}

export function columns(props: Types.Grid.Columns) {
   const size = getSize(props.width);
   if (size === cons.grid.sizes.xxl)
      return css`
         grid-column: auto / span ${props.counts.xxl ? props.counts.xxl : config.xxl.count};
      `;
   if (size === cons.grid.sizes.xl)
      return css`
         grid-column: auto / span ${props.counts.xl ? props.counts.xl : config.xl.count};
      `;
   if (size === cons.grid.sizes.l)
      return css`
         grid-column: auto / span ${props.counts.l ? props.counts.l : config.l.count};
      `;
   if (size === cons.grid.sizes.m)
      return css`
         grid-column: auto / span ${props.counts.m ? props.counts.m : config.m.count};
      `;
   if (size === cons.grid.sizes.s)
      return css`
         grid-column: auto / span ${props.counts.s ? props.counts.s : config.s.count};
      `;
   if (size === cons.grid.sizes.xs)
      return css`
         grid-column: auto / span ${props.counts.xs ? props.counts.xs : config.xs.count};
      `;
}

export function shows(props: Types.Grid.Shows) {
   const size = getSize(props.width);
   if (props.grids[size] === undefined) return true;
   if (size === cons.grid.sizes.xxl && props.grids.xxl) return true;
   if (size === cons.grid.sizes.xl && props.grids.xl) return true;
   if (size === cons.grid.sizes.l && props.grids.l) return true;
   if (size === cons.grid.sizes.m && props.grids.m) return true;
   if (size === cons.grid.sizes.s && props.grids.s) return true;
   if (size === cons.grid.sizes.xs && props.grids.xs) return true;

   return false;
}
